import { Flex, Box, Image } from "@chakra-ui/react";

import { IncreaseDecrease } from "ui/IncreaseDecrease/IncreaseDecrease";
import { BodyM, HeaderS, TitleM } from "ui/Typography/Typography";

export function EquipmentCard({
  name,
  photoUrl,
  depositInEuros,
  counters,
}: {
  name: string;
  photoUrl: string;
  depositInEuros?: number | null;
  counters: {
    label: string;
    count: number;
    updateHandler: (count: number) => void;
  }[];
}) {
  const equimentName = name === "Rot/Red TKTs" ? "TKT/TK Box" : name;
  return (
    <Flex
      direction="column"
      pt="s200"
      pb="s300"
      gap="s200"
      _last={{ paddingBottom: "s200" }}
      _notFirst={{ paddingTop: name === "Blau/Blue TKTs" ? "0" : "s300" }}
      _notLast={{
        borderBottom: name === "Rot/Red TKTs" ? "none" : "1px solid",
        borderColor: "grey.200",
      }}
    >
      {name !== "Blau/Blue TKTs" && (
        <Flex direction="row" gap="s100">
          <Image
            src={photoUrl}
            alt={equimentName}
            w="80px"
            h="80px"
            borderRadius="sm"
            objectFit="contain"
            backgroundColor="grey.100"
          />
          <Box>
            <HeaderS mb="s100">{equimentName}</HeaderS>
            {depositInEuros !== null && <BodyM>{`${depositInEuros} €`}</BodyM>}
          </Box>
        </Flex>
      )}
      {(name === "Rot/Red TKTs" || name === "Blau/Blue TKTs") && <TitleM>{name}</TitleM>}
      <Flex w="full" direction="row" gap="s200">
        {counters.map(({ label, count, updateHandler }) => (
          <IncreaseDecrease
            key={label}
            label={label}
            count={count}
            changeHandler={updateHandler}
            withInput
          />
        ))}
      </Flex>
    </Flex>
  );
}
